export default {
  clientId: 'Client ID',
  reviewedSummaries: 'Reviewed Summaries',
  summaryId: 'Summary ID',
  user: 'User',
  vote: 'Vote',
  comment: 'Comment',
  timestamp: 'Timestamp'
}
